// Qual guia de /manejo/operacoes abre — função pura, para a regra ser testável
// (o repo não tem jsdom). Guias: Lista · Minhas · Semana. A "Hoje" saiu (F3).

export type GuiaOperacoes = "lista" | "minhas" | "semana";

export const GUIAS_OPERACOES: readonly GuiaOperacoes[] = ["lista", "minhas", "semana"];

export interface EntradaGuia {
  /** `?guia=` da URL (nulo se ausente). */
  guia: string | null;
  /** `?vista=` legado (links antigos). */
  vista: string | null;
  funcionarioId: string | null;
  /** Tem `manejo.planejar`. */
  podePlanejar: boolean;
}

/**
 * Sem `guia` na URL: quem NÃO planeja e está ligado a um funcionário abre em
 * Minhas (o operador); os demais, na Lista. `guia=hoje` (e `vista=hoje`) redireciona
 * para Minhas se há vínculo, senão Lista; `vista=semana` honra a Semana; qualquer
 * valor desconhecido cai no padrão — link velho não dá tela branca.
 */
export function guiaInicial(e: EntradaGuia): GuiaOperacoes {
  const padrao: GuiaOperacoes = !e.podePlanejar && e.funcionarioId ? "minhas" : "lista";
  const bruto = e.guia ?? (e.vista === "hoje" || e.vista === "semana" ? e.vista : null);
  if (bruto === null) return padrao;
  if (bruto === "hoje") return e.funcionarioId ? "minhas" : "lista";
  return (GUIAS_OPERACOES as readonly string[]).indexOf(bruto) !== -1 ? (bruto as GuiaOperacoes) : padrao;
}
